import {Address} from '../../../shared/models/adress.model';
import {Association} from '../../../shared/models/association.model';
import {ICountry} from '../../../shared/models/country.interface';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import {AssociationService} from '../../../shared/services/association.service';
import {CountryService} from '../../../shared/services/country.service';
import {Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormGroupDirective, FormControl} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BsLocaleService, defineLocale} from 'ngx-bootstrap';
import {frLocale} from 'ngx-bootstrap/locale';

@Component({
  selector: 'app-association-new',
  templateUrl: './association-new.component.html',
  styleUrls: ['./association-new.component.css']
})
export class AssociationNewComponent implements OnInit {

  @Input() associationCategories;

  @ViewChild('tab1',{static:false}) tab1: ElementRef;
  @ViewChild('tab2',{static:false}) tab2: ElementRef;
  @ViewChild('tab3',{static:false}) tab3: ElementRef;
  @ViewChild('associationDetailsFormEl',{static:false}) associationDetailsFormEl: FormGroupDirective;

  modalTitle = 'Nouvelle Association';
  association: Association = new Association();
  associationDetailsForm: FormGroup;
  associationAdressForm: FormGroup;
  associationReprForm: FormGroup;

  showButtonBack = false;
  showButtonSave = false;
  submitedAssociationDetailsForm = false;
  submittedAssociationAdressForm = false;
  submittedAssociationReprForm = false;

  countries: ICountry[] = [];
  nationalities: any[] = [];

  private tabCurrent = 0;

  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder, private service: AssociationService,
    private bsLocaleService: BsLocaleService, private countryService: CountryService, private slugify: SlugifyPipe) {
    defineLocale(frLocale.abbr, frLocale);
    this.bsLocaleService.use('fr');
    // tslint:disable-next-line:max-line-length
    const patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const patternWebSite = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    const patternAssocCode = /^[a-zA-Z0-9]*$/;

    this.associationDetailsForm = this.formBuilder.group({
      'name': ['', [Validators.required, Validators.minLength(3)]],
      'category': ['', Validators.required],
      'description': ['', Validators.required],
      'email': ['', [Validators.required, Validators.pattern(patternEmail)]],
      'website': ['', [Validators.required, Validators.pattern(patternWebSite)]],
      'recognized_at': ['', Validators.required],
      'published_at': ['', Validators.required],
      'assoc_code': ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4),Validators.pattern(patternAssocCode)]]
    });

    this.associationAdressForm = this.formBuilder.group({
      'country_iso': ['FR', Validators.required],
      'address_line_1': ['', Validators.required],
      'address_line_2': ['', Validators.required],
      'city': ['', Validators.required],
      'state': [''],
      'post_code': ['', Validators.required]
    });

    this.associationReprForm = this.formBuilder.group({
      'firstname': ['', [Validators.required, Validators.minLength(3)]],
      'name': ['', [Validators.required, Validators.minLength(3)]],
      'email': ['', [Validators.required, Validators.pattern(patternEmail)]],
      'birth_date': ['', Validators.required],
      'nationality_iso': ['Française', Validators.required],
      'country_iso': ['FR', Validators.required],
      'address_line_1': [''],
      'address_line_2': [''],
      'city': [''],
      'state': [''],
      'post_code': ['', Validators.required]
    });

    this.countryService.getCountries().subscribe(
      data => {
        this.countries = data;
        this.countries.forEach(country => {
          if (country.nationality.fr && !this.nationalities.includes(country.nationality.fr)) {
            this.nationalities.push(country.nationality.fr);
          }
        });

        this.countries = this.move(this.countries, this.countries.indexOf(this.countries.filter(country => country.alpha2Code === 'FR')[0]), 0);
        this.nationalities = this.move(this.nationalities, this.nationalities.indexOf('Française'), 0);
      }
    );
  }

  ngOnInit() {}

  onSave() {
    if (!this.submitedAssociationDetailsForm || !this.submittedAssociationAdressForm || !this.submittedAssociationReprForm) {
      console.log('aaa', this.submitedAssociationDetailsForm);
      if (!this.submitedAssociationDetailsForm) {
        this.createAssociation();
      } else if (!this.submittedAssociationAdressForm) {
        this.updateAssociationWithAdress();
      } else {
        this.validateAllFormFields(this.associationReprForm);

        if (this.associationReprForm.valid) {
          const representant = Object.assign({}, {
            firstname: this.associationReprForm.value['firstname'],
            name: this.associationReprForm.value['name'],
            email: this.associationReprForm.value['email'],
            birth_date: this.associationReprForm.value['birth_date'],
            nationality_iso: this.associationReprForm.value['nationality_iso']
          });
          representant['assoc_rep_address'] = Object.assign({}, {
            address_line_1: this.associationReprForm.value['address_line_1'],
            address_line_2: this.associationReprForm.value['address_line_2'],
            city: this.associationReprForm.value['city'],
            post_code: this.associationReprForm.value['post_code'],
            state: this.associationReprForm.value['state'],
            country_iso: this.associationReprForm.value['country_iso']
          });
          this.association['assoc_rep'] = representant;
          this.service.update(this.association).subscribe(
            data => {
              (<any>Object).assign(this.association, data);
              this.submittedAssociationReprForm = true;
              this.activeModal.close('assoc-modal-success');
            },
            err => console.log(err)
          );
        }
      }
    }
  }

  onNext() {
    this.tabCurrent++;
    this.onNavigate();
  }

  onBack() {
    this.tabCurrent--;
    this.onNavigate();
  }

  onNavigate() {
    switch (this.tabCurrent) {
      case 0:
        this.modalTitle = 'Nouvelle Association';
        this.showButtonBack = false;
        this.showButtonSave = false;
        this.selectTab(this.tab1);
        break;
      case 1:
        if (!this.submitedAssociationDetailsForm) {
          this.validateAllFormFields(this.associationDetailsForm);
          this.createAssociation();
        } else {
          this.modalTitle = 'Adresse Association';
          this.showButtonBack = true;
          this.showButtonSave = false;
          this.selectTab(this.tab2);
        }
        break;
      case 2:
        if (!this.submittedAssociationAdressForm) {
          this.validateAllFormFields(this.associationAdressForm);
          this.updateAssociationWithAdress();
        } else {
          this.modalTitle = 'Représentant de l\'association';
          this.showButtonBack = true;
          this.showButtonSave = true;
          this.selectTab(this.tab3);
        }
        break;
      default:
        this.modalTitle = 'Nouvelle Association';
        this.showButtonBack = false;
        this.showButtonSave = false;
        this.selectTab(this.tab1);
        break;
    }
  }

  selectTab(tab: ElementRef): void {
    const tabs = [this.tab1, this.tab2, this.tab3];
    tabs.forEach(tabItem => {
      tabItem.nativeElement.classList.remove('active');
    });

    tab.nativeElement.classList.add('active');
  }

  private createAssociation(): void {
    if (this.associationDetailsForm.valid) {
      (<any>Object).assign(this.association, this.associationDetailsForm.value);
      console.log('assoc obj', this.association);
      this.association.url = this.slugify.transform(this.association.name);
      this.service.create(this.association, this.associationDetailsForm.value.category)
        .subscribe(data => {
          (<any>Object).assign(this.association, data);
          console.log('DataAssoc', this.association)
          this.submitedAssociationDetailsForm = true;

          this.modalTitle = 'Adresse Association';
          this.showButtonBack = true;
          this.showButtonSave = false;
          this.selectTab(this.tab2);
        },
        err => {
          console.log(err);
          this.submitedAssociationDetailsForm = false;
          this.tabCurrent = 0;
          alert(err.error.errors[0].details);
        });
    } else {
      this.tabCurrent = 0;
    }
  }

  private updateAssociationWithAdress() {
    if (this.associationAdressForm.valid) {
      this.association.assoc_address = Object.assign({}, this.associationAdressForm.value);
      this.service.update(this.association).subscribe(
        data => {
          (<any>Object).assign(this.association, data);
          this.submittedAssociationAdressForm = true;

          this.modalTitle = 'Représentant de l\'association';
          this.showButtonBack = true;
          this.showButtonSave = true;
          this.selectTab(this.tab3);
        },
        err => console.log(err)
      );
    } else {
      this.tabCurrent = 1;
    }
  }

  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private move(array: any[], from: number, to: number) {
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array;
  };
}
